import { AddCircle, CheckCircle, Clear, Delete, Description, Search, SwapHoriz } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import ConfirmationDialog from "../../../components/confirmationDialog";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DatePickerMui from "../../../components/hookForms/datePicker";
import DialogList from "./modal/dialogList";
import DialogNew from "./modal/dialogNew";
import DialogTransfer from "./modal/dialogTransfer";
import IGenericResult from "../../../interfaces/IGenericResult";
import Tooltip from "@mui/material/Tooltip";
import { format } from "date-fns";
import messages from "../../../utils/messages";
import serviceRevisaoCotaUsina from "../../../services/serviceRevisaoCotaUsina";
import serviceUsina from "../../../services/serviceUsina";
import { toast } from "react-toastify";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

function RevisaoCota(props: any) {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Usinas - Revisão de Cotas");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [approveState, setApproveState] = useState({ data: "", open: false });
    const [exclusionState, setExclusionState] = useState({ data: "", open: false });
    const [openNew, setOpenNew] = useState(false);
    const [openTransfer, setOpenTransfer] = useState({ id: "", info: "", open: false });
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const history = useHistory();
    const [buttonSelected, setButtonSelected] = useState<any[]>(["Novo", "Atual"]);
    const [listErros, setListErros] = useState<string[]>([]);
    const [openModalList, setOpenModalList] = useState(false);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            usinaID: 0,
            statusRevisaoCotaUsina: "Novo,Atual",
            mesAdmissaoRevisao: null,
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 140,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Ver percentuais">
                                <Description />
                            </Tooltip>
                        }
                        label="Ver percentuais"
                        onClick={() => onClickPercentuais(params.id.toString())}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Transferir">
                                <SwapHoriz />
                            </Tooltip>
                        }
                        label="Transferir"
                        onClick={() =>
                            setOpenTransfer({ id: params.id.toString(), info: params.row.nomeUsina, open: true })
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Aprovar">
                                <CheckCircle />
                            </Tooltip>
                        }
                        label="Aprovar"
                        onClick={() => setApproveState({ data: params.id.toString(), open: true })}
                        disabled={params.row.statusRevisaoCotaUsina !== "Novo"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        onClick={() => setExclusionState({ data: params.id.toString(), open: true })}
                        disabled={params.row.statusRevisaoCotaUsina !== "Novo"}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "revisaoCotaUsinaID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            { headerName: "Usina", field: "nomeUsina", type: "string", width: 230 },

            {
                headerName: "Número de revisão",
                field: "numeroRevisao",
                type: "number",
                headerAlign: "left",
                width: 180,
            },

            {
                headerName: "Qtde de instalações",
                field: "quantidadeInstalacoes",
                type: "number",
                headerAlign: "left",
                width: 180,
            },

            {
                headerName: "Data de admissão",
                field: "dataAdmissaoRevisao",
                type: "date",
                width: 180,
            },

            {
                headerName: "Status",
                field: "statusRevisaoCotaUsina",
                type: "string",
                width: 120,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    useEffect(() => {
        setUsinaData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const statusOptions = [
        { label: "Novo", value: "Novo" },
        { label: "Atual", value: "Atual" },
        { label: "Antigo", value: "Antigo" },
    ];

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        if (!filters) {
            filters = { statusRevisaoCotaUsina: "Novo,Atual" };
        }

        serviceRevisaoCotaUsina
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            if (props && props.location && props.location.state) {
                getAllWithFilters(props.location.state);
            } else {
                getAllWithFilters(filters);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [props.Filter, page, pageSize, sortModel]
    );

    const handleDelete = async () => {
        serviceRevisaoCotaUsina
            .delete(exclusionState.data)
            .then((result) => {
                if (result) {
                    toast.success(messages.deleteSucess);
                }
            })
            .catch((err) => {
                toast.error(messages.deleteError, err);
            })
            .finally(() => {
                setExclusionState({ data: "", open: false });
                getAllWithFilters(filters);
            });
    };

    const handleApprove = async () => {
        serviceRevisaoCotaUsina
            .approve(approveState.data)
            .then((result) => {
                if (result) {
                    toast.success(messages.approveSuccess);
                }
            })
            .catch((err) => {
                toast.error(messages.approveError, err);
            })
            .finally(() => {
                setApproveState({ data: "", open: false });
                getAllWithFilters(filters);
            });
    };

    const handleClickOpenNew = () => {
        setOpenNew(true);
    };

    const handleCloseNew = () => {
        setOpenNew(false);
    };

    const onClickPercentuais = (revisaoCotaUsinaID: any) => {
        history.push({
            pathname: "/usinas/revisaoinstalacao",
            state: { revisaoCotaUsinaID: revisaoCotaUsinaID },
        });
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            statusRevisaoCotaUsina: buttonSelected.join(","),
            mesAdmissaoRevisao: values.mesAdmissaoRevisao ? format(values.mesAdmissaoRevisao, "MM/yyyy") : "",
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            reset(props.location.state);
            setFilters(props.location.state);
            getAllWithFilters(props.location.state);
        }
    }, [props]);

    const onClear = () => {
        setButtonSelected(["Novo", "Atual"]);
        reset({ usinaID: 0, statusRevisaoCotaUsina: "Novo,Atual" });
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    useEffect(() => {
        if (listErros.length > 0) {
            setOpenModalList(true);
        }
    }, [listErros]);

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <AutoComplete
                                                name="usinaID"
                                                label="Nome da usina"
                                                options={usinaDataOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <DatePickerMui
                                                name="mesAdmissaoRevisao"
                                                label="Última atualização"
                                                format="MM/yyyy"
                                                view={["month", "year"]}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <Button
                                                style={{ marginTop: 16, marginBottom: 8 }}
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddCircle />}
                                                onClick={handleClickOpenNew}
                                                disableElevation
                                                fullWidth
                                                size="medium"
                                            >
                                                Novo
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={8} display="flex" alignItems="center">
                                    <Grid container columnSpacing={2}>
                                        <Grid item sx={{ mt: 2 }}>
                                            <Typography variant="subtitle2" color="#5B5B5F">
                                                Status:
                                                {statusOptions.map((item, index) => {
                                                    return (
                                                        <Button
                                                            key={index}
                                                            variant={
                                                                buttonSelected.includes(item.value)
                                                                    ? "contained"
                                                                    : "outlined"
                                                            }
                                                            color="warning"
                                                            size="small"
                                                            disableElevation
                                                            onClick={() => {
                                                                setButtonSelected((oldstate) => {
                                                                    if (oldstate.includes(item.value)) {
                                                                        return oldstate.filter((e) => e !== item.value);
                                                                    } else {
                                                                        return [...oldstate, item.value];
                                                                    }
                                                                });
                                                            }}
                                                            style={{
                                                                margin: "0px 12px",
                                                                minWidth: "120px",
                                                                height: "33px",
                                                            }}
                                                        >
                                                            {item.label}
                                                        </Button>
                                                    );
                                                })}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <Button
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="outlined"
                                        color="warning"
                                        startIcon={<Clear />}
                                        onClick={() => onClear()}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                    >
                                        Limpar
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.revisaoCotaUsinaID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <ConfirmationDialog
                        open={exclusionState?.open}
                        title={"Excluir"}
                        message={messages.deleteConfirmation}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => setExclusionState({ data: "", open: false })}
                        onCancel={() => setExclusionState({ data: "", open: false })}
                        onConfirm={() => {
                            setExclusionState({ data: "", open: false });
                            handleDelete();
                        }}
                    />

                    <ConfirmationDialog
                        open={approveState?.open}
                        title={"Aprovar"}
                        message={"Tem certeza que deseja aprovar essa revisão?"}
                        cancelButtonText={"Cancelar"}
                        confirmButtonText={"Confirmar"}
                        onClose={() => setApproveState({ data: "", open: false })}
                        onCancel={() => setApproveState({ data: "", open: false })}
                        onConfirm={() => {
                            setApproveState({ data: "", open: false });
                            handleApprove();
                        }}
                    />

                    <DialogNew
                        open={openNew}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            handleCloseNew();
                        }}
                        returnDate={(item) => {
                            if (item.length > 0) {
                                setListErros(item);
                            }
                        }}
                    />

                    <DialogTransfer
                        open={openTransfer.open}
                        data={{ ...openTransfer }}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => setOpenTransfer({ id: "", info: "", open: false })}
                    />

                    {openModalList && <DialogList data={listErros} onClose={() => setOpenModalList(false)} />}
                </CardContent>
            </Card>
        </Container>
    );
}

export default RevisaoCota;
